import { Component, OnInit, OnDestroy } from '@angular/core';
import {Http, Headers, RequestOptions,Response} from '@angular/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {ShareService } from './../services/services';
import {Contact,ContactService } from './contact.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { Title } from '@angular/platform-browser';
import { AlertService} from './../services/alert.service';
interface PageData {
  title: string;
  description: string;
  meta_title: string;
  meta_description: string;
  address: string;
  email: string;
  contactno: string;
  
  
}
@Component({
    selector: 'contactus-component',
	//template: require('./contacthome.component.html')
	templateUrl: './pg/contact/contacthome.component.html',
	
	//templateUrl: './../../../../storage/app/uploads/page.component.html'
	
})

export class ContactHomeComponent implements OnInit {
	
	
	pagedata: PageData;
	public serviceData;
	private _sub: Subscription;
	public metatitle;
	public apiData;
	public params;
	public siteinfo;
    public metadescription;
    ContactUsForm: FormGroup;
	constructor(
	    private http: Http,
	    private _route: ActivatedRoute,
	    private _router: Router,
	    private shareService: ShareService,
	    private _title: Title,
	    private alertService: AlertService,
	    public fb: FormBuilder,
	    private _pageService: ContactService) {
		   
		   this.pagedata = {
                  title:'',                  
                  description: '',
                  meta_title: '',
                  meta_description: '',
                  address:'',
                  email:'',
                  contactno:''
                 
				  	}
				  	
		  this.ContactUsForm = fb.group({
      'email': [
        '', // default value
        Validators.compose([Validators.required, Validators.minLength(5)])
      ],
      'name': [
        '',
        Validators.compose([Validators.required, Validators.minLength(5)])
      ],
      'phone': [
        '',
        Validators.compose([Validators.required, Validators.minLength(5)])
      ],
      'message': [
        '',
        Validators.compose([Validators.required, Validators.minLength(5)])
      ]


    });
	    }
	    

	ngOnInit() {
	
	    // this.pagedata.email=this.shareService.getemail();
	     
	     ///alert(this.shareService.getemail());
	    // this.pagedata.description="umesh naga";
	    //  this.pagedata.slug="umesh hhhnaga";
	   // alert("page");
	   
	  setTimeout(()=>{    //<<<---    using ()=> syntax
         
         

      this.siteinfo=this.shareService.getsiteinfo();    
      //console.log("Mydata->"+this.siteinfo.site_address);  
      if(this.siteinfo!=undefined)
      {      
      this.pagedata.address=this.siteinfo.address;
      this.pagedata.email=this.siteinfo.email;
      this.pagedata.contactno=this.siteinfo.contactno;
      }
	  },1500);
	  
		
	
		
	}

    ngOnDestroy() {
       //this._sub.unsubscribe();
    }
     ContactUsValidate(): boolean {

  if (this.ContactUsForm.valid) {
    return true;
  }
  let errorMsg = '';
  

  let field_name = this.ContactUsForm.controls['name'];
  if (!field_name.valid) {
    if (field_name.errors['required']) {
      errorMsg = 'Provide a Name please.<br />';
    }
  }

  let fieldemail = this.ContactUsForm.controls['email'];
  if (!fieldemail.valid) {
    if (fieldemail.errors['required']) {
      errorMsg = errorMsg+'Provide a Email please.<br />';
    }
  }
  
  let fieldmesage = this.ContactUsForm.controls['message'];
  if (!fieldmesage.valid) {
    if (fieldmesage.errors['required']) {
      errorMsg = errorMsg+'Provide a Message please.<br />';
    }
  }
 if(errorMsg!="")
 {
    //alert(errorMsg);
    this.alertService.error(errorMsg);
    
  return false;
  }
  else
  {
    return true;
  }
}
    doContactUs(event) {
       
     if (this.ContactUsValidate()) {
    
            let name = this.ContactUsForm.controls['name'].value;            
			let phone =this.ContactUsForm.controls['phone'].value;
			let email = this.ContactUsForm.controls['email'].value;
	        let subject ='';
			let message = this.ContactUsForm.controls['message'].value;
            this.params = {
                 
                  name: name,
                  email: email,
                  phone: phone,
                  subject:subject,
                  message:message,
                };
               this._pageService.doContactUs(this.params).subscribe(
        data => {
            this.apiData = data;           
             //loading.dismiss();
             if(data.status=='success')
             {
	              this.alertService.success(data.message);
	              this.reset();
	              
	              
	              
             }
             else
             {
	             this.alertService.error(data.message);
             }

         },
        err => console.error(err),
        () => console.log('services completed')
    );
               console.log(this.ContactUsForm.value);
               
               
              
    };
  }
  
    reset() {
     this.ContactUsForm.reset();
       }
     


}


// WEBPACK FOOTER //
// ./resources/assets/typescript/contact/contacthome.component.ts